// `audio.voiceover`: a talking head's voiceover (#222).
// Live's Talking Head voiceover: its form makes these, not a Studio draft.
import { AudioVoiceoverQuote, AudioVoiceoverRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"audio.voiceover"> = {
  type: "audio.voiceover",
  label: "Voiceover",
  source: "form",
  pair: "audio.voiceover",
  fields: (draft) => commonFields(draft),
  request: AudioVoiceoverRequest,
  quote: AudioVoiceoverQuote,
};
